var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"px-2 d-flex align-center justify-center",staticStyle:{"border-radius":"12px","font-size":"13px","line-height":"1.5"},attrs:{"color":_vm.count ? _vm.color : 'disabled darken-1',"dark":"","height":"20","minWidth":"20"}},[_vm._v(" "+_vm._s(_vm.count)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }